export const sharedApiDefinitions = Object.freeze({
	apiPostToolWaitlistJoin: ["api/public/waitinglist/tool"],
	apiPostWorkflowWaitlistJoin: ["api/public/waitinglist/workflow"],
})
